export const GET_SCOPE_OF_WORK_QUERY = `
  query GetScopeOfWork($where: scope_of_work_bool_exp = {}) {
    scope_of_work(where: $where, order_by: { created_at: desc }) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const GET_SCOPE_OF_WORK_BY_ID_QUERY = `
  query GetScopeOfWorkById($id: Int!) {
    scope_of_work_by_pk(id: $id) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`; 